export default "__VITE_ASSET__DqGtQh_O__"